import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

registerCardTemplate({
    id: 'radial-gauge-2',
    name: 'Radial Gauge ',
    description: 'A dynamic radial gauge that displays a single value pushed from Lucy. Your data source needs to provide a single value. Data can be updated by either pushing data into a specific channel from Lucy or by configuring this widget to regularly poll for new updates.',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-radial-gauge-2" */ "./RadialGaugeTemplateNew")),
    icon: generateIconProp('tachometerAlt'),
    complexity: 'easy',
    preLoader: 'gauge',
    layout: {
        w: 8,
        h: 10
    },
    expectedSchema: 'dictionary',
    canDragDropFields: true
});
